<template>
    <div>

		<div class="main-content">
			<div class="container-fluid">
				<div class="row justify-content-center">
					<div class="col-12 col-lg-10 col-xl-8">

						<!-- Header -->
						<div class="header mt-md-5">
							<div class="header-body">
								<div class="row align-items-center">
									<div class="col">
										<!-- Title -->
										<h1 class="header-title">
											Add Career
										</h1>
									</div>
								</div> <!-- / .row -->
							</div>
						</div>

						<!-- Content -->

						<div class="mt-3 mb-5">
							<div>
								<p>Fields marked <span class="text-danger">*</span> are required</p>
							</div>

                            <form>
								<div class="form-group">
									<div class="row">
										<div class="col-md-5">
											<label for="">Title <span class="text-danger">*</span></label>
											<input type="text" name="title" id="title" class="form-control"
												v-model="addData.title" v-validate="'required'"
											>
											<span class="text-danger d-block">{{ errors.first('title') }}</span>

										</div>

									</div>
								</div>

                                <div class="form-group">
                                    <label class="d-block" id="status">Status <span class="text-danger">*</span></label>
                                    <span class="text-danger d-block">{{ errors.first('status') }}</span>

                                    <div class="row">
                                        <div class="col-md-5">

                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="status1" name="status" class="custom-control-input"
                                                    v-model="addData.status" value="1" v-validate="'required|included:1,2'"
                                                >
                                                <label class="custom-control-label" for="status1">Published</label>
                                            </div>

                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="status2" name="status" class="custom-control-input"
                                                    v-model="addData.status" value="2"
                                                >
                                                <label class="custom-control-label" for="status2">Draft</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group mt-4">
                                    <div class="row">
										<div class="col-md-4 ">
											<button class="btn btn-success btn-block"
												v-on:click.prevent="addCareer($event)"
											>
												Save
											</button>
										</div>
									</div>
                                </div>

                            </form>


						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: 'Add',
        data() {
            return {
                addData: {
                    title: '',
                    content: '',
                    status: null
                }
            }
        },
        methods: {
            addCareer(e) {
                $('.s-v-e').remove();
                let self = this;
                let btn = e.currentTarget;

                this.$validator.validateAll().then((result) => {
                    if (result) {
                        let formData = {
                            title: this.addData.title,
                            status: this.addData.status
                        };
                        $(btn).addClass('is-loading is-loading-sm').attr('disabled', '');

                        axios.post(APIURL + 'admin/add/career', JSON.stringify(formData))
                        .then((response) => {
                            $(btn).removeClass('is-loading is-loading-sm').removeAttr('disabled');

                            let res = response.data;
                            if (res.status == 200) {
                                this.addData.title = '';
                                this.addData.status = '';

                                this.$validator.reset();
                                this.$swal('Success', res.msg, 'success');
                            }
                            else {
                                if (res.status == 403) {
                                    $.each(res.errors, (k, v) => {
                                        $('#' + k).after(v);
                                    })
                                }
                                else {
                                    this.$swal('Error', res.msg, 'error');
                                }
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        })
                        
                        
                    }
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/backend/careers/Add.vue